
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 63 56"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M50 31.748c-6.204 0-11.252 5.048-11.252 11.252 0 6.204 5.048 11.252 11.252 11.252 6.204 0 11.252-5.048 11.252-11.252 0-6.204-5.048-11.252-11.252-11.252M50 56c-7.169 0-13-5.831-13-13s5.831-13 13-13 13 5.831 13 13-5.831 13-13 13"}}),_c('path',{attrs:{"d":"M34.249 51H6.594C2.96 51 0 48.075 0 44.482V10.52C0 6.925 2.96 4 6.594 4h40.812C51.043 4 54 6.925 54 10.52v15.908h-1.784V10.52c0-2.623-2.158-4.756-4.81-4.756H6.594c-2.652 0-4.81 2.133-4.81 4.756v33.963c0 2.622 2.158 4.755 4.81 4.755H34.25V51z"}}),_c('path',{attrs:{"d":"M12 10h2V0h-2zm14 0h2V0h-2zm14 0h2V0h-2zM46.388 38.125l8.41 8.421-1.185 1.186-8.412-8.421zm7.224.143l1.187 1.186-8.412 8.421-1.185-1.186z"}})])
          )
        }
      }
    